module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Virginia  Hamilton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Virginia Hamilton (1934–2002) was the author of over forty books for children, young adults, and their older allies. Throughout a career that spanned four decades, Hamilton earned numerous accolades for her work, including nearly every major award available to writers of youth literature. In 1974, "), _c('I', [_vm._v("M.C. Higgins, the Great")]), _vm._v(" earned Hamilton the National Book Award, the Newbery Medal (which she was the first African-American author to receive), and the "), _c('I', [_vm._v("Boston Globe–Horn ")]), _c('I', [_vm._v("Book")]), _vm._v(" Award, three of the field’s most prestigious awards. She received the Hans Christian Andersen Award, the highest international recognition bestowed on a writer of books for young readers, in 1992, and in 1995 became the first children’s book author to receive a MacArthur Fellowship, or “Genius Award.” She was also the recipient of the Coretta Scott King Award.")], 1), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JgAhZL/tc-custom/9781453213841.jpg?1733096587056",
      "alt": "This image is the cover for the book Cousins"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cousins\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Cammy’s only trouble in life is a cousin named Patty Ann who overshadows her in every way—until suddenly, Patty Ann is no longer around")]), _vm._v(" "), _c('br'), _vm._v("Cammy has a happy life and a great family, except for one little problem: a cousin who thinks she’s better than everyone else. It’s true that Patty Ann is beautiful, talented, and bright, but to Cammy she’s also vain, conceited, and mean-spirited. Sometimes Cammy wishes that Patty Ann would disappear, just vanish in a puff of smoke. But when the unthinkable happens and Patty Ann is lost forever, Cammy struggles to atone for her bad feelings toward someone so close.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0